<template lang="pug">
  div
    section.content-header
      h1(v-if="add") 組織情報の作成
      h1(v-else) 組織情報の変更

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li
          router-link(:to="{name: 'group'}") 組織管理
        li.active(v-if="add") 組織情報の作成
        li.active(v-else) 組織情報の変更

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .bcard-btnbar.clearfix(v-if="add", class!=attributes.class)
            .pull-left
              button.btn.btn-primary(type="submit", title="作成") 作成
              |
              |
              router-link.btn.btn-default(:to="{name: 'group', params: {defaultId: defaultId, defaultName: defaultName}}", type="button", title="キャンセル") キャンセル
          .bcard-btnbar.clearfix(v-else, class!=attributes.class)
            .pull-left
              button.btn.btn-primary(type="submit", title="変更") 変更
              |
              |
              router-link.btn.btn-default(:to="{name: 'group', params: {defaultId: defaultId, defaultName: defaultName}}", type="button", title="キャンセル") キャンセル
              |
              |
              .btn-separator
              |
              |
              button.btn.btn-danger(@click="showModalDelete", type="button", title="削除") 削除
        +btnbar

        .box.box-widget
          .box-body
            label.control-label 親組織
            div.bcard-group-select-group-area
              button.btn.btn-success(type="button", title="親組織の選択", @click="sendGroupModalFlag")
                | 親組織の選択
              span.bcard-ui-userdata
                span.bcard-deselect(v-if="parent.id", @click="setDeselectedId", title='解除')
                  | &nbsp;
                  i.fa.fa-times.fa-fw
                  | &nbsp;
                span(:title="parent.name") {{parent.name}}

            .form-group
              label.control-label
                | 組織名
                span.bcard-required (*)
              input.form-control(type="text", v-model="item.name", :maxlength="maxlengths.name", required)
              .help-block
                p.bcard-comments.text-info ※ 組織名の先頭文字に「*」「@」は使用できません。

            .form-group
              label.control-label 企業内組織コード
              input.form-control(type="text", v-model="item.orgconst_id", :maxlength="maxlengths.orgconst_id")

            .form-group
              label.control-label 連絡先
              input.form-control(type="text" v-model="item.tel", :maxlength="maxlengths.tel")

            .form-group
              label.control-label メモ
              textarea.form-control(rows="3" v-model="item.memo", :maxlength="maxlengths.memo")

            p.bcard-required ※ (*)は必須項目です。

        +btnbar

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(v-model="modalDelete" type="danger" v-if="this.id")
      template(slot="title") 組織情報の削除
      h4 組織情報を削除します。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(@click="deleteGroup") 削除
        button.btn.btn-default(@click="close") キャンセル

    template(v-if="init")
      modal-sel-group(
        @set-groups="setParent",
        @complete-deselection="unsetDeselectedId",
        @get-flag="initGroupModalFlag",
        :openFlag="groupModalFlag",
        :defaultGroups="[parent]",
        :deselectedId="deselectedId"
      )
</template>
<script>
import AppModal from '@/components/templates/AppModal'
import ModalSelGroup from '@/components/organisms/ModalSelGroup'
import AppMessages from '@/components/molecules/AppMessages'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const GroupRepository = RepositoryFactory.get('group')

export default {
  name: 'GroupEdit',
  components: { AppModal, AppMessages, ModalSelGroup },
  mixins: [ mixinForm ],
  props: {
    // 追加
    defaultId: {type: Number, required: false, default: null},
    defaultName: {type: String, required: false, default: ''},
    // 変更
    id: {type: String, required: false, default: null},
    item: {
      type: Object,
      required: false,
      default: function () {
        return {
          name: '',
          orgconst_id: '',
          tel: '',
          memo: ''
        }
      }
    }
  },
  data: function () {
    return {
      // 初期データ取得済みフラグ
      init: false,
      parent: {
        id: null,
        name: ''
      },
      // 組織選択ダイアログに渡す選択解除ID
      deselectedId: null,
      // 削除確認ダイアログ表示フラグ
      modalDelete: false,
      // 組織選択ダイアログ表示フラグ
      groupModalFlag: false,
      // 追加処理か
      add: false,
      maxlengths: {}
    }
  },
  created: function () {
    this.maxlengths = this.loadMaxlengths('Groups')

    // 追加
    if (this.id === null) {
      this.add = true
      // 一覧から渡された親組織を選択(ルートは入れない)
      if (this.defaultId !== null) {
        this.parent.id = this.defaultId
        this.parent.name = this.defaultName
      }
      this.init = true
    }
    // 変更
    else {
      const vm = this
      GroupRepository.get(this.id).then(function (response) {
        // 成功
        let data = vm.getApiData(response).data
        vm.item.name = data.name
        vm.item.orgconst_id = data.orgconst_id
        vm.item.tel = data.tel
        vm.item.memo = data.memo
        vm.parent.id = data.parent_id
        vm.parent.name = vm.parent.id ? data.parent_name : ''
        vm.init = true
      }).catch(function (error) {
        // データが無い場合は一覧へ
        vm.setErrorMessage(error)
        vm.$router.push({name: 'group'})
        vm.$store.commit('setFlashMessages', vm.errors)
      })
    }
  },
  methods: {
    // 組織選択ダイアログ側で実行
    setParent (tree_groups) {
      // 組織選択ダイアログで選択中の親組織を取得
      if (tree_groups[0]) {
        this.parent = tree_groups[0]
      }
      else {
        this.parent.id = null
        this.parent.name = null
      }
    },
    // 組織選択ダイアログに選択を解除させる
    setDeselectedId () {
      this.deselectedId = this.parent.id
    },
    // 組織選択ダイアログの選択解除完了後の処理
    unsetDeselectedId () {
      // 親組織を未選択にする
      this.parent.id = null
      this.parent.name = null
      this.deselectedId = null
    },
    // 追加・変更ボタン押下時
    postData () {
      if (!this.checkFormValidity()) return

      const vm = this
      const data = {
        name: this.item.name,
        orgconst_id: this.item.orgconst_id,
        tel: this.item.tel,
        memo: this.item.memo,
        parent_id: this.parent.id
      }
      // 追加
      if (this.add) {
        GroupRepository.post(data).then(function (response) {
          vm.$router.push({
            name: 'group',
            params: {defaultId: vm.parent.id,
              defaultName: vm.parent.name
            }
          })
        }).catch(function (error) {
          // エラー時はメッセージを表示
          vm.setErrorMessage(error)
        })
      }
      // 変更
      else {
        GroupRepository.put(this.id, data).then(function (response) {
          vm.$router.push({
            name: 'group',
            params: {defaultId: vm.parent.id,
              defaultName: vm.parent.name
            }
          })
        }).catch(function (error) {
          // エラー時はメッセージを表示
          vm.setErrorMessage(error)
        })
      }
    },
    // 削除ボタン押下時
    deleteGroup () {
      const vm = this

      // 削除API実行
      GroupRepository.delete(this.id).then(function (response) {
        // 成功時は一覧画面に遷移
        vm.$router.push({
          name: 'group',
          params: {defaultId: vm.parent.id,
            defaultName: vm.parent.name
          }
        })
      }).catch(function (error) {
        // エラー時はメッセージを表示
        vm.setErrorMessage(error)
      })
      this.modalDelete = false
    },
    // 削除確認ダイアログ表示
    showModalDelete () {
      this.modalDelete = true
    },
    // 組織選択ダイアログにフラグを渡す
    sendGroupModalFlag () {
      this.groupModalFlag = true
    },
    // 組織選択ダイアログのフラグを更新した時点でフラグを下げる
    initGroupModalFlag () {
      this.groupModalFlag = false
    }
  }
}
</script>
<style lang="scss" scoped>
.bcard-group-select-group-area {
  display: flex;
  line-height: 30px;
  padding-bottom: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/group/Edit.vue